import React, { useEffect, useMemo } from "react";

import { useSearchspringSearchContext } from "@app/providers/searchspring";
import { useSearchspringOption } from "@app/hooks/use-searchspring-option";

import { CardProduct } from "@app/components/card-product";
import { useSearchspringFilters } from "@app/hooks/use-searchspring-filters";

const TARGET_FACET_FIELD = "mfield_dotapparel_gender";

export function SearchResults() {
  const { response } = useSearchspringSearchContext();

  const { activeFilters, handleToggleFilter, handleRemoveAllByField } = useSearchspringFilters({ syncWithURL: false });

  const query = useSearchspringOption("query", {
    defaultValue: "",
  });

  // TODO: use gender once product has been properly loaded in
  const facet = useMemo(() => {
    return response?.facets?.find((facet) => facet.field === TARGET_FACET_FIELD);
  }, [response?.facets]);

  useEffect(() => {
    handleRemoveAllByField(TARGET_FACET_FIELD);
  }, [query]);

  if (!response) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between gap-4 mx-auto max-w-240 max-md:flex-col md:items-center">
        <h4 className="shrink-0">Top results for "{query}"</h4>
        {!facet?.values.length ? null : (
          <div className="flex gap-2 overflow-x-scroll no-scrollbar">
            <button
              data-ui={activeFilters.size === 0 && "active"}
              className="btn btn-sm btn-outline-light shrink-0 ui-[active]:bg-neutrals-black ui-[active]:text-neutrals-white"
              onClick={() => handleRemoveAllByField(TARGET_FACET_FIELD)}
            >
              All
            </button>
            {facet.values.map((value) => {
              const filter = `${TARGET_FACET_FIELD}:${value.value}`;
              return (
                <button
                  key={value.value}
                  data-ui={activeFilters.has(filter) && "active"}
                  className="btn btn-sm btn-outline-light shrink-0 ui-[active]:bg-neutrals-black ui-[active]:text-neutrals-white"
                  onClick={() => {
                    handleRemoveAllByField(TARGET_FACET_FIELD);
                    handleToggleFilter(filter);
                  }}
                >
                  {value.label}
                </button>
              );
            })}
          </div>
        )}
      </div>

      <div className="m-auto">
        <hr className="bg-neutrals-grey-4" />
      </div>
      <div className="grid grid-cols-2 gap-4 px-4 md:grid-cols-5 md:gap-8 md:pb-0">
        {response.results?.map((result) => {
          if (typeof result === "string") return null;
          return <CardProduct source="searchspring" data={result} key={result.handle} />;
        })}
      </div>
      <hr className="bg-neutrals-grey-4" />
      <div className="sticky bottom-0 left-0 right-0 p-4 pb-24 bg-neutrals-white md:relative md:p-0">
        <a
          href={`/search?query=${query}`}
          className="justify-center w-full mx-auto btn btn-md btn-solid-light md:w-2/5"
        >
          Show all {response.pagination.totalResults} results
        </a>
      </div>
    </div>
  );
}
